import {
  IAPIApplicationSettingsModel,
  IAPIApplicationSubAccountBusinessModel,
  IAPIOpenAISettingsDataModel,
  IAPIPurchaseDomains,
} from "../interfaces";

export class ApplicationSettingsModel {
  purchaseDomains: PurchaseAllowedDomainsModel[];
  fundraiserDomain: string;
  openAISettings?: OpenAISettingsDataModel
  /* Browser-usable provider keys, configured in the Payment DB ApplicationSettings document instead
     of being hard-coded in the bundle (security findings F03/F03b). */
  unsplashAccessKey: string;
  googleMapsAPIKey: string;

  constructor(data?: Partial<ApplicationSettingsModel>) {
    this.purchaseDomains =
      data?.purchaseDomains?.map((d) => new PurchaseAllowedDomainsModel(d)) ||
      [];
    this.fundraiserDomain = data?.fundraiserDomain || "";
    this.openAISettings = data?.openAISettings
      ? new OpenAISettingsDataModel(data.openAISettings)
      : undefined;
    this.unsplashAccessKey = data?.unsplashAccessKey || "";
    this.googleMapsAPIKey = data?.googleMapsAPIKey || "";
  }

  static deserializeAPIModel(
    data: IAPIApplicationSettingsModel
  ): ApplicationSettingsModel {
    const mappedData: Partial<ApplicationSettingsModel> = {
      purchaseDomains: data?.purchaseDomains?.map((d) =>
        PurchaseAllowedDomainsModel.deserializeAPIModel(d)
      ),
      fundraiserDomain: data?.fundRaiserDomain || "",
      openAISettings: data?.openAISettings
        ? OpenAISettingsDataModel.deserializeAPIModel(data.openAISettings)
        : undefined,
      unsplashAccessKey: data?.unsplashAccessKey || "",
      googleMapsAPIKey: data?.googleMapsAPIKey || "",
    };

    return new ApplicationSettingsModel(mappedData);
  }
}


export class PurchaseAllowedDomainsModel {
  domain: string;
  constructor(data?: Partial<PurchaseAllowedDomainsModel>) {
    this.domain = (data && data.domain) || "";
  }

  static deserializeAPIModel(
    data: IAPIPurchaseDomains
  ): PurchaseAllowedDomainsModel {
    const mappedData: Partial<IAPIPurchaseDomains> = {
      domain: data?.domain || "",
    };
    return new PurchaseAllowedDomainsModel(mappedData);
  }
}


export class OpenAISettingsDataModel {
  apiKey: string = "";
  textModel: string = "gpt-4o";
  imageModel: string = "gpt-image-1";

  constructor(data?: Partial<OpenAISettingsDataModel>) {
    this.apiKey = data?.apiKey ?? "";
    this.textModel = data?.textModel ?? "gpt-4o";
    this.imageModel = data?.imageModel ?? "gpt-image-1";
  }

  static deserializeAPIModel(
    data: IAPIOpenAISettingsDataModel
  ): OpenAISettingsDataModel {
    return new OpenAISettingsDataModel({
      apiKey: data.apiKey,
      textModel: data.textModel,
      imageModel: data.imageModel,
    });
  }
}

export class ApplicationSubAccountBusinessModel {
  businessName: string = "";
  businessAddress1: string = "";
  businessAddress2?: string;
  city?: string
  stateId?: string;
  zipCode?: string;
  countryId?: string;
  constructor(data?: Partial<ApplicationSubAccountBusinessModel>) {
    this.businessName = data?.businessName ?? "";
    this.businessAddress1 = data?.businessAddress1 ?? "";
    this.businessAddress2 = data?.businessAddress2;
    this.city = data?.city;
    this.stateId = data?.stateId;
    this.zipCode = data?.zipCode;
    this.countryId = data?.countryId;
  }

  static deserializeAPIModel(
    data: IAPIApplicationSubAccountBusinessModel
  ): ApplicationSubAccountBusinessModel {
    return new ApplicationSubAccountBusinessModel({
      businessName: data.name,
      businessAddress1: data.address1,
      businessAddress2: data.address2,
      city: data.city,
      stateId: data.stateId,
      zipCode: data.zipCode,
      countryId: data.countryId,
    })
  }
}